import {
  KAFAIR_RAFFLE_GROUP,
  KA_FAIR_RAFFLE,
  KA_FAIR_RAFFLE_LIST,
  SET_USER_RAFFLE_TICKET,
  KA_FAIR_RAFFLE_LIST_CLOSED,
  SET_PRODUCT_RAFFLE_COUNT,
  KA_PREVIEW_RAFFLE,
  GET_COLLECTION_KICKFAIR,
  GET_COLLECTION_STEAL_DEAL,
  GET_COLLECTION_STEAL_DEAL_LIST,
  GET_COLLECTION_SPECIAL_DEALS_GOLD,
  GET_COLLECTION_SPECIAL_DEALS_CAPSULE,
  GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD,
  GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE,
  GET_LOCAL_BRANDS_PRODUCT,
  GET_LOCAL_BRANDS_BRANDS,
  GET_IMAGE_BANNER_LOCAL_BRANDS,
  SCROLL_TO_SECTION,
  GET_KICKFAIR_SETTING,
  GET_IMAGE_BANNER_MERCHANDISE,
  GET_MERCHANDISE_PRODUCT,
  KA_POST_RAFFLE_ENTRY,
  GET_COLLECTION_LOCAL_BRANDS,
  GET_COLLECTION_FLASH_SALE,
  GET_COLLECTION_EXCLUSIVE_LAUNCH,
  GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST,
  GET_COLLECTION_SURPRISE_DROP,
  GET_COLLECTION_SURPRISE_DROP_LIST,
  GET_POPULAR_BRANDS,
  GET_COLLECTION_SNEAKERS_NOVEMBAZAR,
  GET_COLLECTION_STREETWEAR_NOVEMBAZAR,
  GET_COLLECTION_LUXURY_NOVEMBAZAR,
  GET_COLLECTION_LIFESTYLE_NOVEMBAZAR,
  GET_RAFFLE_BANNER
} from "../constants/kafairConstants";
import {
  GET_COLLECTION_UNDER_RETAIL,
  GET_COLLECTION_MERCHANDISE,
  GET_PRE_VERIFIED_COLLECTION_LIST
} from "../constants"
import {
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  PROMISE_PENDING
} from "../constants";
import error from "../utils/error";
import _ from "lodash";

const initialState = {
  previewRaffle: {
    data: [],
    isFetching: false,
    error: null,
    status_code: 200
  },
  flashSale: {
    data: [],
    isFetching: false,
    error: null,
    status_code: 200
  },
  raffleGroup: {
    isFetching: false,
    error: null,
    data: []
  },
  raffle: {
    isFetching: false
  },
  raffleBanner: {
    isFetching: false,
    error: null,
    data: []
  },
  raffleList: {},
  userRaffleTicket: {
    isFetching: false,
    data: {},
    error: null,
    status_code: 200
  },
  exclusive_launch: {
    dataList: [],
    products: {
      data: [],
      isFetching: false,
      hasMoreData: false,
      error: null
    },
    isFetching: false,
    error: null,
    status_code: 200,
    status_code: 200,
    isActive: false,
    expiry: null
  },
  steal_deal: {
    title: "",
    isActive: false,
    dataList: [],
    expiry: null,
    products: {
      data: [],
      isFetching: false,
      hasMoreData: false,
      error: null
    },
    imageBanner: null,
    hasMoreData: false,
    error: null,
    kafair: {
      imagesPortrait: null,
      imagesLandscape: null
    },
    error: null,
    isFetching: false,
    status_code: null
  },
  special_deals_gold: {
    title: "",
    isActive: false,
    dataList: [],
    starts_at: null,
    expiry: null,
    products: {
      data: [],
      isFetching: false,
      hasMoreData: false,
      error: null
    },
    imageBanner: null,
    hasMoreData: false,
    error: null,
    kafair: {
      isFetching: false,
      error: null,
      imagesPortrait: null,
      imagesLandscape: null
    },
    error: null,
    isFetching: false,
    status_code: null
  },
  special_deals_capsule: {
    title: "",
    isActive: false,
    dataList: [],
    starts_at: null,
    expiry: null,
    products: {
      data: [],
      isFetching: false,
      hasMoreData: false,
      error: null
    },
    imageBanner: null,
    hasMoreData: false,
    error: null,
    kafair: {
      isFetching: false,
      error: null,
      imagesPortrait: null,
      imagesLandscape: null
    },
    error: null,
    isFetching: false,
    status_code: null
  },
  local_brands: {
    title: "",
    isActive: false,
    kafair: {
      isFetching: false,
      error: null,
      imagesPortrait: null,
      imagesLandscape: null
    },
    mainBanner: {
      isFetching: false,
      error: null,
      imagesPortrait: null,
      imagesLandscape: null
    },
    products: {
      data: [],
      isFetching: false,
      error: null,
      status_code: null,
      hasMoreData: false
    },
    brands: {
      data: [],
      isFetching: false,
      error: null,
      status_code: null,
      hasMoreData: false
    }
  },
  redeemRaffle: {
    isFetching: false,
    error: null
  },
  raffleProducts: {},
  totalEntry: {},
  scroll_to: null,
  isKickFairActive: false,
  official_merchandise: {
    title: "",
    isActive: false,
    description: "",
    products: {
      data: [],
      isFetching: false,
      error: null,
      status_code: null,
      hasMoreData: false
    },
    isFetching: false,
    status_code: null,
    error: null,
    kafair: {
      isFetching: false,
      error: null,
      imagesPortrait: null,
      imagesLandscape: null
    }
  },
  surprise_drop: {
    dataList: [],
    products: {
      data: [],
      isFetching: false,
      hasMoreData: false,
      error: null
    },
    isFetching: false,
    error: null,
    status_code: 200,
    isActive: false,
    expiry: null
  },
  categoryBrand: {
    popularBrands: [],
    isFetching: false,
    status_code: 200,
    error: null
  },
  sneakers_harbolnas: {
    title: "",
    isActive: false,
    productList: [],
    error: null,
    hasMoreData: false
  },
  streetwear_harbolnas: {
    title: "",
    isActive: false,
    productList: [],
    error: null,
    hasMoreData: false
  },
  luxury_harbolnas: {
    title: "",
    isActive: false,
    productList: [],
    error: null,
    hasMoreData: false
  },
  lifestyle_harbolnas: {
    title: "",
    isActive: false,
    productList: [],
    error: null,
    hasMoreData: false
  },
  under_retail: {
    data: [],
    error: null,
    isFetching: false
  },
  merchandise: {
    data: [],
    error: null,
    isFetching: false
  },
  pre_verified_list: {
    data: [],
    isFetching: false,
    error: null
  }
};

function normalize_raffle_product(products) {
  try {
    if (!products || products.length === 0) return [];
    const normalizedProducts = products.map(p => {
      const {
        product_id,
        display_name,
        SKU,
        currency,
        release_date,
        product: { brand },
        pivot: { retail_price, raffle_id }
      } = p;

      const productImage = p.product_variant_images.length > 0 ? p.product_variant_images[0].URL : null;

      return {
        id: raffle_id,
        product_id,
        display_name,
        SKU,
        currency,
        release_date,
        brand,
        price: retail_price,
        image: productImage
      };
    });

    return normalizedProducts;
  } catch (err) {
    console.log("normalize raffle product error: ", err);
  }
}

function normalize_raffle_product_list(dates) {
  try {
    if (!dates)
      return {
        active: {
          list: {}
        }
      };

    let list = {};

    if (Object.keys(dates).length) {
      Object.keys(dates).map(d => {
        list[d] = {
          start: dates[d].data[0].pivot.started_at,
          expiry: dates[d].data[0].pivot.expiry,
          products: dates[d].data.map(d => ({
            id: d.pivot.raffle_id,
            variant_id: d.pivot.variant_id,
            price: d.pivot.retail_price,
            display_name: d.display_name,
            active: d.active,
            SKU: d.SKU,
            brand: d.product.brand,
            image: d.product_variant_images.length > 0 ? d.product_variant_images[0].URL : null
          }))
        };
      });
    }

    return {
      active: {
        list
      }
    };
  } catch (err) {
    console.log("normalize_raffle_product_list error: ", err);
  }
}
function normalize_preview_raffle(data) {
  if (!data) return null;

  return {
    group_name: data.group_name,
    data: normalize_raffle_product(data.data),
    isGolden: data.data[0].pivot.golden,
    start_date: data.started_at,
    expiry: data.expiry,
    img_url: null
  };
}

const raffleGroupData = (
  state,
  { data: { data, last_page, current_page, per_page, total }, status_code }
) => {
  try {
    // const group_names = data && data[0]
    //   ? data[0].value.split(",").map(r => r.trim().toLowerCase().replace(/\s/g, "+"))
    //   : []

    let newState = {
      ...state,
      raffleGroup: {
        ...state.raffleGroup,
        isFetching: false,
        data: data && data[0] ? data[0].value : [],
        status_code,
        last_page,
        current_page,
        per_page,
        total
      }
    };
    return newState;
  } catch (e) {
    return {
      ...state,
      raffleGroup: {
        ...state.raffleGroup,
        isFetching: false,
        data: [],
        status_code,
        last_page,
        current_page,
        per_page,
        total
      }
    };
  }
};

const raffleTodayData = (
  state,
  {
    data: { data, raffle, last_page, current_page, per_page, total },
    status_code
  }
) => {
  try {
    const decoded_group_name = raffle.group_name
      .toLowerCase()
      .replace(/\s/gi, "+");

    let newState = {
      ...state,
      raffle: {
        ...state.raffle,
        isFetching: false,
        [decoded_group_name]: {
          ...state.raffle[decoded_group_name],
          group_name: decoded_group_name,
          products: normalize_raffle_product(data),
          start_date: raffle.started_at,
          golden: raffle.golden,
          expiry: raffle.expiry,
          terms: raffle.terms,
          description: raffle.description,
          img_url: raffle.img_url
        }
      }
    };
    return newState;
  } catch (e) {
    return {
      ...state,
      raffle: {
        ...state.raffle,
        isFetching: false,
        error: e
      }
    };
  }
};

const raffleListData = (
  state,
  {
    data: { dates, raffle, last_page, current_page, per_page, total },
    status_code
  }
) => {
  try {
    const decoded_group_name = raffle.group_name
      .toLowerCase()
      .replace(/\s/gi, "+");

    let newState = {
      ...state,
      raffleList: {
        ...state.raffleList,
        isFetching: false,
        [decoded_group_name]: {
          ...state.raffleList[decoded_group_name],
          group_name: decoded_group_name,
          ...normalize_raffle_product_list(dates)
        }
      }
    };
    return newState;
  } catch (e) {
    return {
      ...state,
      raffle: {
        ...state.raffle,
        isFetching: false,
        error: e
      }
    };
  }
};

const raffleListDataClosed = (
  state,
  {
    data: { data, raffle, last_page, current_page, per_page, total },
    status_code
  }
) => {
  try {
    if (!raffle)
      return {
        ...state,
        raffleList: {
          ...state.raffleList,
          isFetching: false
        }
      };

    const decoded_group_name = raffle.group_name
      .toLowerCase()
      .replace(/\s/gi, "+");

    let newState = {
      ...state,
      raffleList: {
        ...state.raffleList,
        isFetching: false,
        [decoded_group_name]: {
          ...state.raffleList[decoded_group_name],
          closed: normalize_raffle_product(data)
        }
      }
    };
    return newState;
  } catch (e) {
    return {
      ...state,
      raffle: {
        ...state.raffle,
        isFetching: false,
        error: e
      }
    };
  }
};

const previewRaffleData = (
  state,
  {
    data: { data, raffle, last_page, current_page, per_page, total },
    status_code
  }
) => {
  try {
    const defaultRaffle = {
      data: [],
      start_date: null,
      isGolden: false,
      expiry: null,
      img_url: null
    };

    const lists = data.map(d => normalize_preview_raffle(d) || defaultRaffle);

    let newState = {
      ...state,
      previewRaffle: {
        ...state.previewRaffle,
        isFetching: false,
        lists
      }
    };
    return newState;
  } catch (e) {
    return {
      ...state,
      previewRaffle: {
        ...state.previewRaffle,
        isFetching: false,
        error: e
      }
    };
  }
};

const raffleProducts = (
  state,
  { ticket_type, raffle_id, data, status_code }
) => {
  try {
    let newState = {
      ...state,
      raffleProducts: {
        ...state.raffleProducts,
        isFetching: false,
        [raffle_id]: data[ticket_type].total
      },
      totalEntry: {
        ...state.totalEntry,
        isFetching: false,
        [raffle_id]: data[ticket_type].total_entry
      }
    };
    return newState;
  } catch (e) {
    return {
      ...state,
      previewRaffle: {
        ...state.previewRaffle,
        isFetching: false,
        error: e
      }
    };
  }
};

const collectionData = (
  state,
  { data: { data, last_page, current_page, per_page, total }, status_code },
  name
) => {
  let newState = {
    ...state,
    exclusiveLaunch: {
      ...state.exclusiveLaunch,
      isFetching: false,
      data: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  };
  return newState;
};

const collectionProductData = (
  state,
  {
    products: { data, next_page_url, current_page },
    categories,
    name: title,
    active,
    slug,
    expiry,
    starts_at
  },
  name
) => {
  const imageBanner =
    categories.length > 0 &&
    categories[0].pivot &&
    categories[0].pivot.images.length > 0 &&
    categories[0].pivot.images.find(item => item.orientation === "landscape");

  const newData = _.uniqBy([...state[name].products.data, ...data], "id");

  const newState = {
    ...state,
    [name]: {
      ...state[name],
      title,
      isActive: active,
      isFetching: false,
      slug,
      imageBanner: imageBanner ? imageBanner.URL : null,
      expiry,
      starts_at,
      error: null,
      products: {
        data: current_page === 1 ? data : newData,
        isFetching: false,
        hasMoreData: next_page_url,
        error: null,
        status_code: 200
      }
    }
  };

  return newState;
};

const collectionNoCategory = (
  state,
  { products: { data, next_page_url, current_page } },
  name
) => {
  // const imageBanner = categories.length > 0 && categories[0].pivot && categories[0].pivot.images.length > 0 && categories[0].pivot.images.find(item => item.orientation === "landscape")
  // const newData = _.uniqBy([
  //   ...state[name].productList,
  //   ...data
  // ], 'id')

  const newData = [
    {
      ...state[name].dataProducts,
      ...data
    }
  ];

  const newState = {
    ...state,
    [name]: {
      ...state[name],
      isFetching: false,
      dataProducts: current_page === 1 ? data : newData,
      // imageBanner: imageBanner ? imageBanner.URL : null,
      hasMoreData: next_page_url,
      status_code: 200,
      error: null
    }
  };

  return newState;
};

const popularBrandList = (state, data, name) => {
  const newState = {
    ...state,
    categoryBrand: {
      ...state.categoryBrand,
      popularBrands: data,
      isFetching: false,
      status_code: 200,
      error: null
    }
  };

  return newState;
};

const kafairReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${KAFAIR_RAFFLE_GROUP}${PROMISE_PENDING}`:
      return {
        ...state,
        raffleGroup: { ...state.raffleGroup, isFetching: true }
      };
    case `${KAFAIR_RAFFLE_GROUP}${PROMISE_FULFILLED}`:
      return raffleGroupData(state, action.payload);
    case `${KAFAIR_RAFFLE_GROUP}${PROMISE_REJECTED}`:
      return {
        ...state,
        raffleGroup: {
          ...state.raffleGroup,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${KA_PREVIEW_RAFFLE}${PROMISE_PENDING}`:
      return {
        ...state,
        previewRaffle: { ...state.previewRaffle, isFetching: true }
      };
    case `${GET_COLLECTION_UNDER_RETAIL}${PROMISE_PENDING}`:
      return {
        ...state,
        under_retail: {
          isFetching: true,
          data: [],
          error: null
        }
      };
    case `${GET_COLLECTION_UNDER_RETAIL}${PROMISE_REJECTED}`:
      return {
        ...state,
        under_retail: {
          isFetching: false,
          data: [],
          error: action.payload
        }
      };
    case `${GET_COLLECTION_UNDER_RETAIL}${PROMISE_FULFILLED}`:
      return {
        ...state,
        under_retail: {
          ...state.under_retail,
          isFetching: false,
          error: null,
          data: action.payload.data.data,
          hasMoreData: action.payload.data.next_page_url
        }
      };
    case `${GET_COLLECTION_MERCHANDISE}${PROMISE_PENDING}`:
      return {
        ...state,
        merchandise: {
          isFetching: true,
          data: [],
          error: null
        }
      };
    case `${GET_COLLECTION_MERCHANDISE}${PROMISE_REJECTED}`:
      return {
        ...state,
        merchandise: {
          isFetching: false,
          data: [],
          error: action.payload
        }
      };
    case `${GET_COLLECTION_MERCHANDISE}${PROMISE_FULFILLED}`:
      return {
        ...state,
        merchandise: {
          ...state.merchandise,
          isFetching: false,
          error: null,
          data: action.payload.data.data,
          hasMoreData: action.payload.data.next_page_url
        }
      };
    case `${KA_PREVIEW_RAFFLE}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;

      return {
        ...state,
        previewRaffle: {
          ...state.previewRaffle,
          isFetching: false,
          error: null,
          data: data.data,
          status_code
        }
      };
    }
    case `${KA_PREVIEW_RAFFLE}${PROMISE_REJECTED}`:
      return {
        ...state,
        previewRaffle: {
          ...state.previewRaffle,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${SET_USER_RAFFLE_TICKET}${PROMISE_PENDING}`:
      return {
        ...state,
        userRaffleTicket: {
          ...state.userRaffleTicket,
          isFetching: true,
          error: null
        }
      };
    case `${GET_PRE_VERIFIED_COLLECTION_LIST}${PROMISE_REJECTED}`:
      return {
        ...state,
        pre_verified_list: {
          ...state.pre_verified_list,
          isFetching: false,
          error: error(action.payload)
        }
      };
    case `${GET_PRE_VERIFIED_COLLECTION_LIST}${PROMISE_PENDING}`:
      return {
        ...state,
        pre_verified_list: {
          ...state.pre_verified_list,
          isFetching: true,
          error: null
        }
      };
    case `${GET_PRE_VERIFIED_COLLECTION_LIST}${PROMISE_FULFILLED}`:
      return {
        ...state,
        pre_verified_list: {
          ...state.pre_verified_list,
          isFetching: false,
          error: null,
          data: action.payload.data.data.length ? action.payload.data.data[0].value : []
        }
      };
    case `${SET_USER_RAFFLE_TICKET}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;

      return {
        ...state,
        userRaffleTicket: {
          ...state.userRaffleTicket,
          isFetching: false,
          data: action.payload.data,
          error: null
        }
      };
    }
    case `${SET_USER_RAFFLE_TICKET}${PROMISE_REJECTED}`: {
      return {
        ...state,
        userRaffleTicket: {
          ...state.userRaffleTicket,
          isFetching: false,
          error: error(action.payload)
        }
      };
    }
    case `${GET_COLLECTION_KICKFAIR}${PROMISE_PENDING}`:
      return {
        ...state,
        exclusiveLaunch: { ...state.raffleHistory, isFetching: true }
      };
    case `${GET_COLLECTION_KICKFAIR}${PROMISE_FULFILLED}`:
      return collectionData(state, action.payload, action.name);
    case `${GET_COLLECTION_KICKFAIR}${PROMISE_REJECTED}`:
      return {
        ...state,
        exclusiveLaunch: {
          ...state.exclusiveLaunch,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_STEAL_DEAL}${PROMISE_PENDING}`:
      return {
        ...state,
        steal_deal: { ...state.steal_deal, isFetching: true }
      };
    case `${GET_COLLECTION_STEAL_DEAL}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;

      return {
        ...state,
        steal_deal: {
          ...state.steal_deal,
          dataList: data.data,
          status_code,
          isFetching: false,
          error: null
        }
      };
    }
    case `${GET_COLLECTION_STEAL_DEAL}${PROMISE_REJECTED}`:
      return {
        ...state,
        steal_deal: {
          ...state.steal_deal,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_STEAL_DEAL_LIST}${PROMISE_PENDING}`:
      return {
        ...state,
        steal_deal: {
          ...state.steal_deal,
          products: {
            ...state.steal_deal.products,
            isFetching: true
          }
        }
      };
    case `${GET_COLLECTION_STEAL_DEAL_LIST}${PROMISE_FULFILLED}`: {
      const {
        data: { data, next_page_url, current_page },
        status_code
      } = action.payload;

      const newData = _.uniqBy(
        [...state.steal_deal.products.data, ...data],
        "id"
      );

      return {
        ...state,
        steal_deal: {
          ...state.steal_deal,
          products: {
            ...state.steal_deal.products,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            status_code: status_code,
            hasMoreData: next_page_url
          }
        }
      };
    }
    case `${GET_COLLECTION_STEAL_DEAL_LIST}${PROMISE_REJECTED}`:
      return {
        ...state,
        steal_deal: {
          ...state.steal_deal,
          products: {
            ...state.steal_deal.products,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_COLLECTION_SPECIAL_DEALS_GOLD}${PROMISE_PENDING}`:
      return {
        ...state,
        special_deals_gold: {
          ...state.special_deals_gold,
          isFetching: true,
          products: { ...state.special_deals_gold.products, isFetching: true }
        }
      };
    case `${GET_COLLECTION_SPECIAL_DEALS_GOLD}${PROMISE_FULFILLED}`: {
      if (action.payload.data && action.payload.data.products) {
        return collectionProductData(
          state,
          action.payload.data,
          "special_deals_gold"
        );
      } else {
        const {
          data: { data, current_page, next_page_url },
          status_code
        } = action.payload;
        const newData = _.uniqBy(
          [...state.special_deals_gold.products.data, ...data],
          "id"
        );

        return {
          ...state,
          special_deals_gold: {
            ...state.special_deals_gold,
            error: null,
            products: {
              isFetching: false,
              data: current_page === 1 ? data : newData,
              status_code,
              hasMoreData: next_page_url
            }
          }
        };
      }
    }
    case `${GET_COLLECTION_SPECIAL_DEALS_GOLD}${PROMISE_REJECTED}`:
      return {
        ...state,
        special_deals_gold: {
          ...state.special_deals_gold,
          isFetching: false,
          error: error(action.payload),
          products: { ...state.special_deals_gold.products, isFetching: false }
        }
      };

    case `${GET_COLLECTION_SNEAKERS_NOVEMBAZAR}${PROMISE_PENDING}`:
      return {
        ...state,
        sneakers_harbolnas: {
          ...state.sneakers_harbolnas,
          isFetching: true,
        }
      };
    case `${GET_COLLECTION_SNEAKERS_NOVEMBAZAR}${PROMISE_FULFILLED}`: {
      if (action.payload.data && action.payload.data.products) {
        return collectionProductData(
          state,
          action.payload.data,
          "sneakers_harbolnas"
        );
      } else {
        const {
          data: { data, current_page, next_page_url },
          status_code
        } = action.payload;
        const newData = _.uniqBy(
          [...state.sneakers_harbolnas.productList, ...data],
          "id"
        );

        return {
          ...state,
          sneakers_harbolnas: {
            ...state.sneakers_harbolnas,
            error: null,
            isFetching: false,
            productList: current_page === 1 ? data : newData,
            status_code,
            hasMoreData: next_page_url
          }
        };
      }
    }
    case `${GET_COLLECTION_SNEAKERS_NOVEMBAZAR}${PROMISE_REJECTED}`:
      return {
        ...state,
        sneakers_harbolnas: {
          ...state.sneakers_harbolnas,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_STREETWEAR_NOVEMBAZAR}${PROMISE_PENDING}`:
      return {
        ...state,
        streetwear_harbolnas: {
          ...state.streetwear_harbolnas,
          isFetching: true
        }
      };
    case `${GET_COLLECTION_STREETWEAR_NOVEMBAZAR}${PROMISE_FULFILLED}`: {
      if (action.payload.data && action.payload.data.products) {
        return collectionProductData(
          state,
          action.payload.data,
          "streetwear_harbolnas"
        );
      } else {
        const {
          data: { data, current_page, next_page_url },
          status_code
        } = action.payload;
        const newData = _.uniqBy(
          [...state.streetwear_harbolnas.productList, ...data],
          "id"
        );

        return {
          ...state,
          streetwear_harbolnas: {
            ...state.streetwear_harbolnas,
            error: null,
            isFetching: false,
            productList: current_page === 1 ? data : newData,
            status_code,
            hasMoreData: next_page_url,
          }
        };
      }
    }
    case `${GET_COLLECTION_STREETWEAR_NOVEMBAZAR}${PROMISE_REJECTED}`:
      return {
        ...state,
        streetwear_harbolnas: {
          ...state.streetwear_harbolnas,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_LUXURY_NOVEMBAZAR}${PROMISE_PENDING}`:
      return {
        ...state,
        luxury_harbolnas: {
          ...state.luxury_harbolnas,
          isFetching: true
        }
      };
    case `${GET_COLLECTION_LUXURY_NOVEMBAZAR}${PROMISE_FULFILLED}`: {
      if (action.payload.data && action.payload.data.products) {
        return collectionProductData(
          state,
          action.payload.data,
          "luxury_harbolnas"
        );
      } else {
        const {
          data: { data, current_page, next_page_url },
          status_code
        } = action.payload;
        const newData = _.uniqBy(
          [...state.luxury_harbolnas.productList, ...data],
          "id"
        );

        return {
          ...state,
          luxury_harbolnas: {
            ...state.luxury_harbolnas,
            error: null,
            isFetching: false,
            productList: current_page === 1 ? data : newData,
            status_code,
            hasMoreData: next_page_url,
          }
        };
      }
    }
    case `${GET_COLLECTION_LUXURY_NOVEMBAZAR}${PROMISE_REJECTED}`:
      return {
        ...state,
        luxury_harbolnas: {
          ...state.luxury_harbolnas,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_LIFESTYLE_NOVEMBAZAR}${PROMISE_PENDING}`:
      return {
        ...state,
        lifestyle_harbolnas: {
          ...state.lifestyle_harbolnas,
          isFetching: true
        }
      };
    case `${GET_COLLECTION_LIFESTYLE_NOVEMBAZAR}${PROMISE_FULFILLED}`: {
      if (action.payload.data && action.payload.data.products) {
        return collectionProductData(
          state,
          action.payload.data,
          "lifestyle_harbolnas"
        );
      } else {
        const {
          data: { data, current_page, next_page_url },
          status_code
        } = action.payload;
        const newData = _.uniqBy(
          [...state.lifestyle_harbolnas.productList, ...data],
          "id"
        );

        return {
          ...state,
          lifestyle_harbolnas: {
            ...state.lifestyle_harbolnas,
            error: null,
            isFetching: false,
            productList: current_page === 1 ? data : newData,
            status_code,
            hasMoreData: next_page_url
          }
        };
      }
    }
    case `${GET_COLLECTION_LIFESTYLE_NOVEMBAZAR}${PROMISE_REJECTED}`:
      return {
        ...state,
        lifestyle_harbolnas: {
          ...state.lifestyle_harbolnas,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_SPECIAL_DEALS_CAPSULE}${PROMISE_PENDING}`:
      return {
        ...state,
        special_deals_capsule: {
          ...state.special_deals_capsule,
          isFetching: true,
          products: {
            ...state.special_deals_capsule.products,
            isFetching: true
          }
        }
      };
    case `${GET_COLLECTION_SPECIAL_DEALS_CAPSULE}${PROMISE_FULFILLED}`: {
      if (action.payload.data && action.payload.data.products) {
        return collectionProductData(
          state,
          action.payload.data,
          "special_deals_capsule"
        );
      } else {
        const {
          data: { data, current_page, next_page_url },
          status_code
        } = action.payload;
        const newData = _.uniqBy(
          [...state.special_deals_capsule.products.data, ...data],
          "id"
        );

        return {
          ...state,
          special_deals_capsule: {
            ...state.special_deals_capsule,
            error: null,
            products: {
              isFetching: false,
              data: current_page === 1 ? data : newData,
              status_code,
              hasMoreData: next_page_url
            }
          }
        };
      }
    }
    case `${GET_COLLECTION_SPECIAL_DEALS_CAPSULE}${PROMISE_REJECTED}`:
      return {
        ...state,
        special_deals_capsule: {
          ...state.special_deals_capsule,
          isFetching: false,
          error: error(action.payload),
          products: {
            ...state.special_deals_capsule.products,
            isFetching: false
          }
        }
      };

    case `${GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD}${PROMISE_PENDING}`:
      return {
        ...state,
        special_deals_gold: {
          ...state.special_deals_gold,
          kafair: { ...state.special_deals_gold.kafair, isFetching: true }
        }
      };
    case `${GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD}${PROMISE_FULFILLED}`: {
      const {
        data: { categories }
      } = action.payload;

      const imagesLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "landscape"
        );

      const imagesPortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "portrait"
        );

      return {
        ...state,
        special_deals_gold: {
          ...state.special_deals_gold,
          kafair: {
            ...state.special_deals_gold.kafair,
            isFetching: false,
            imagesLandscape: imagesLandscape ? imagesLandscape.URL : null,
            imagesPortrait: imagesPortrait ? imagesPortrait.URL : null
          }
        }
      };
    }
    case `${GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD}${PROMISE_REJECTED}`:
      return {
        ...state,
        special_deals_gold: {
          ...state.special_deals_gold,
          kafair: {
            ...state.special_deals_gold.kafair,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE}${PROMISE_PENDING}`:
      return {
        ...state,
        special_deals_capsule: {
          ...state.special_deals_capsule,
          kafair: { ...state.special_deals_capsule.kafair, isFetching: true }
        }
      };
    case `${GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE}${PROMISE_FULFILLED}`: {
      const {
        data: { categories }
      } = action.payload;

      const imagesLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "landscape"
        );

      const imagesPortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "portrait"
        );

      return {
        ...state,
        special_deals_capsule: {
          ...state.special_deals_capsule,
          kafair: {
            ...state.special_deals_capsule.kafair,
            isFetching: false,
            imagesLandscape: imagesLandscape ? imagesLandscape.URL : null,
            imagesPortrait: imagesPortrait ? imagesPortrait.URL : null
          }
        }
      };
    }
    case `${GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE}${PROMISE_REJECTED}`:
      return {
        ...state,
        special_deals_capsule: {
          ...state.special_deals_capsule,
          kafair: {
            ...state.special_deals_capsule.kafair,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_LOCAL_BRANDS_PRODUCT}${PROMISE_PENDING}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          products: {
            ...state.local_brands.products,
            isFetching: true
          }
        }
      };

    case `${GET_LOCAL_BRANDS_PRODUCT}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;
      const { data: productList = [], next_page_url, current_page } = data || {}
      const newData = _.uniqBy(
        [...state.local_brands.products.data, ...data.data],
        "id"
      );

      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          products: {
            ...state.local_brands.products,
            isFetching: false,
            data: current_page === 1 ? productList : newData,
            status_code: status_code,
            hasMoreData: data.next_page_url
          }
        }
      };
    }

    case `${GET_LOCAL_BRANDS_PRODUCT}${PROMISE_REJECTED}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          products: {
            ...state.local_brands.products,
            isFetching: false,
            error: error(action.payload),
            data: []
          }
        }
      };

    case `${GET_IMAGE_BANNER_LOCAL_BRANDS}${PROMISE_PENDING}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          kafair: {
            ...state.local_brands.kafair,
            isFetching: true
          }
        }
      };

    case `${GET_IMAGE_BANNER_LOCAL_BRANDS}${PROMISE_FULFILLED}`: {
      const {
        data: { name, active, categories, slug },
        status_code
      } = action.payload;
      const imagesLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "landscape"
        );

      const imagesPortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "portrait"
        );

      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          title: name,
          isActive: active,
          slug,
          kafair: {
            ...state.local_brands.kafair,
            isFetching: false,
            imagesLandscape: imagesLandscape ? imagesLandscape.URL : null,
            imagesPortrait: imagesPortrait ? imagesPortrait.URL : null,
            status_code
          }
        }
      };
    }

    case `${GET_IMAGE_BANNER_LOCAL_BRANDS}${PROMISE_REJECTED}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          kafair: {
            ...state.local_brands.kafair,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_LOCAL_BRANDS_BRANDS}${PROMISE_PENDING}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          brands: {
            ...state.local_brands.brands,
            isFetching: true
          }
        }
      };

    case `${GET_LOCAL_BRANDS_BRANDS}${PROMISE_FULFILLED}`: {
      const {
        data: {
          brands: { data, current_page, next_page_url }
        },
        status_code
      } = action.payload;

      const newData = _.uniqBy(
        [...state.local_brands.brands.data, ...data],
        "id"
      );

      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          brands: {
            ...state.local_brands.brands,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            status_code: status_code,
            hasMoreData: next_page_url
          }
        }
      };
    }

    case `${GET_LOCAL_BRANDS_BRANDS}${PROMISE_REJECTED}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          brands: {
            ...state.local_brands.brands,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_IMAGE_BANNER_MERCHANDISE}${PROMISE_PENDING}`:
      return {
        ...state,
        official_merchandise: {
          ...state.official_merchandise,
          kafair: {
            ...state.official_merchandise.kafair,
            isFetching: true
          }
        }
      };

    case `${GET_IMAGE_BANNER_MERCHANDISE}${PROMISE_FULFILLED}`: {
      const {
        data: { name, active, categories, slug, description },
        status_code
      } = action.payload;
      const imagesLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "landscape"
        );

      const imagesPortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "portrait"
        );

      return {
        ...state,
        official_merchandise: {
          ...state.official_merchandise,
          title: name,
          isActive: active,
          description,
          slug,
          kafair: {
            ...state.official_merchandise.kafair,
            isFetching: false,
            imagesLandscape: imagesLandscape ? imagesLandscape.URL : null,
            imagesPortrait: imagesPortrait ? imagesPortrait.URL : null,
            status_code
          }
        }
      };
    }

    case `${GET_IMAGE_BANNER_MERCHANDISE}${PROMISE_REJECTED}`:
      return {
        ...state,
        official_merchandise: {
          ...state.official_merchandise,
          kafair: {
            ...state.official_merchandise.kafair,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_MERCHANDISE_PRODUCT}${PROMISE_PENDING}`:
      return {
        ...state,
        official_merchandise: {
          ...state.official_merchandise,
          products: {
            ...state.official_merchandise.products,
            isFetching: true
          }
        }
      };
    case `${GET_MERCHANDISE_PRODUCT}${PROMISE_FULFILLED}`: {
      const {
        data: { data, next_page_url, current_page },
        status_code
      } = action.payload;

      const newData = _.uniqBy(
        [...state.official_merchandise.products.data, ...data],
        "id"
      );

      return {
        ...state,
        official_merchandise: {
          ...state.official_merchandise,
          products: {
            ...state.official_merchandise.products,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            status_code: status_code,
            hasMoreData: next_page_url
          }
        }
      };
    }
    case `${GET_MERCHANDISE_PRODUCT}${PROMISE_REJECTED}`:
      return {
        ...state,
        official_merchandise: {
          ...state.official_merchandise,
          products: {
            ...state.official_merchandise.products,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${KA_FAIR_RAFFLE}${PROMISE_PENDING}`:
      return { ...state, raffle: { ...state.raffle, isFetching: true } };
    case `${KA_FAIR_RAFFLE}${PROMISE_FULFILLED}`:
      return raffleTodayData(state, action.payload);
    case `${KA_FAIR_RAFFLE}${PROMISE_REJECTED}`:
      return {
        ...state,
        raffle: {
          ...state.raffle,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${KA_FAIR_RAFFLE_LIST}${PROMISE_PENDING}`:
      return {
        ...state,
        raffleList: { ...state.raffleList, isFetching: true }
      };
    case `${KA_FAIR_RAFFLE_LIST}${PROMISE_FULFILLED}`:
      return raffleListData(state, action.payload);
    case `${KA_FAIR_RAFFLE_LIST}${PROMISE_REJECTED}`:
      return {
        ...state,
        raffleList: {
          ...state.raffleList,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${KA_FAIR_RAFFLE_LIST_CLOSED}${PROMISE_PENDING}`:
      return {
        ...state,
        raffleList: { ...state.raffleList, isFetching: true }
      };
    case `${KA_FAIR_RAFFLE_LIST_CLOSED}${PROMISE_FULFILLED}`:
      return raffleListDataClosed(state, action.payload);
    case `${KA_FAIR_RAFFLE_LIST_CLOSED}${PROMISE_REJECTED}`:
      return {
        ...state,
        raffleList: {
          ...state.raffleList,
          isFetching: false,
          error: error(action.payload)
        }
      };

    // case `${KA_PREVIEW_RAFFLE}${PROMISE_PENDING}`:
    //   return { ...state, previewRaffle: { ...state.previewRaffle, isFetching: true } }
    // case `${KA_PREVIEW_RAFFLE}${PROMISE_FULFILLED}`:
    //   return (previewRaffleData(state, action.payload))
    // case `${KA_PREVIEW_RAFFLE}${PROMISE_REJECTED}`:
    //   return { ...state, previewRaffle: { ...state.previewRaffle, isFetching: false, error: error(action.payload) } }

    case `${SET_PRODUCT_RAFFLE_COUNT}${PROMISE_PENDING}`:
      return {
        ...state,
        raffleProducts: { ...state.raffleProducts, isFetching: true }
      };
    case `${SET_PRODUCT_RAFFLE_COUNT}${PROMISE_FULFILLED}`:
      return raffleProducts(state, action.payload);
    case `${SET_PRODUCT_RAFFLE_COUNT}${PROMISE_REJECTED}`:
      return {
        ...state,
        raffleProducts: {
          ...state.raffleProducts,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${KA_POST_RAFFLE_ENTRY}${PROMISE_PENDING}`:
      return {
        ...state,
        redeemRaffle: { ...state.redeemRaffle, isFetching: true }
      };
    case `${KA_POST_RAFFLE_ENTRY}${PROMISE_FULFILLED}`:
      return {
        ...state,
        redeemRaffle: {
          ...state.redeemRaffle,
          redeemedTicket: action.payload.sumOfTicket,
          isFetching: false,
          error: null
        }
      };
    case `${KA_POST_RAFFLE_ENTRY}${PROMISE_REJECTED}`:
      return {
        ...state,
        redeemRaffle: {
          ...state.redeemRaffle,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${SCROLL_TO_SECTION}`:
      return { ...state, scroll_to: action.payload };

    case `${GET_KICKFAIR_SETTING}${PROMISE_FULFILLED}`: {
      const {
        data
      } = action.payload;
      const isActive = data.data.find(t => t.value_type === "date")?.active ?? false;

      return { ...state, isKickFairActive: isActive };
    }
    case `${GET_KICKFAIR_SETTING}${PROMISE_REJECTED}`:
      return { ...state, isKickFairActive: false };

    case `${GET_COLLECTION_LOCAL_BRANDS}${PROMISE_PENDING}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          mainBanner: { ...state.local_brands.mainBanner, isFetching: true }
        }
      };
    case `${GET_COLLECTION_LOCAL_BRANDS}${PROMISE_FULFILLED}`: {
      const {
        data: { categories, brands: { data } }
      } = action.payload;

      const imagesLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "landscape"
        );

      const imagesPortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "portrait"
        );

      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          mainBanner: {
            ...state.local_brands.mainBanner,
            isFetching: false,
            imagesLandscape: imagesLandscape ? imagesLandscape.URL : null,
            imagesPortrait: imagesPortrait ? imagesPortrait.URL : null
          },
          brands: {
            ...state.local_brands.brands,
            data: data
          }
        }
      };
    }
    case `${GET_COLLECTION_LOCAL_BRANDS}${PROMISE_REJECTED}`:
      return {
        ...state,
        local_brands: {
          ...state.local_brands,
          mainBanner: {
            ...state.local_brands.mainBanner,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_COLLECTION_FLASH_SALE}${PROMISE_PENDING}`:
      return {
        ...state,
        flashSale: {
          ...state.flashSale,
          mainBanner: { ...state.flashSale.mainBanner, isFetching: true }
        }
      };
    case `${GET_COLLECTION_FLASH_SALE}${PROMISE_FULFILLED}`: {
      const {
        data: { categories }
      } = action.payload;

      const imagesLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "landscape"
        );

      const imagesPortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          item => item.orientation === "portrait"
        );

      return {
        ...state,
        flashSale: {
          ...state.flashSale,
          data: action.payload.data.products.data,
          mainBanner: {
            ...state.flashSale.mainBanner,
            isFetching: false,
            imagesLandscape: imagesLandscape ? imagesLandscape.URL : null,
            imagesPortrait: imagesPortrait ? imagesPortrait.URL : null
          }
        }
      };
    }
    case `${GET_COLLECTION_FLASH_SALE}${PROMISE_REJECTED}`:
      return {
        ...state,
        flashSale: {
          ...state.flashSale,
          mainBanner: {
            ...state.flashSale.mainBanner,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };

    case `${GET_COLLECTION_EXCLUSIVE_LAUNCH}${PROMISE_PENDING}`:
      return {
        ...state,
        exclusive_launch: { ...state.exclusive_launch, isFetching: true }
      };
    case `${GET_COLLECTION_EXCLUSIVE_LAUNCH}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;

      return {
        ...state,
        exclusive_launch: {
          ...state.exclusive_launch,
          dataList: data.data,
          status_code,
          isFetching: false,
          error: null
        }
      };
    }
    case `${GET_COLLECTION_EXCLUSIVE_LAUNCH}${PROMISE_REJECTED}`:
      return {
        ...state,
        exclusive_launch: {
          ...state.exclusive_launch,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_SURPRISE_DROP}${PROMISE_PENDING}`:
      return {
        ...state,
        surprise_drop: { ...state.surprise_drop, isFetching: true }
      };
    case `${GET_COLLECTION_SURPRISE_DROP}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;

      return {
        ...state,
        surprise_drop: {
          ...state.surprise_drop,
          dataList: data.data,
          status_code,
          isFetching: false,
          error: null
        }
      };
    }
    case `${GET_COLLECTION_SURPRISE_DROP}${PROMISE_REJECTED}`:
      return {
        ...state,
        surprise_drop: {
          ...state.surprise_drop,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_COLLECTION_SURPRISE_DROP_LIST}${PROMISE_PENDING}`:
      return {
        ...state,
        surprise_drop: {
          ...state.surprise_drop,
          products: {
            ...state.surprise_drop.products,
            isFetching: true
          }
        }
      };

    case `${GET_COLLECTION_SURPRISE_DROP_LIST}${PROMISE_FULFILLED}`: {
      const {
        data: {
          products: { data, next_page_url, current_page }
        },
        status_code
      } = action.payload;
      const newData = [
        {
          ...state.surprise_drop.products.data,
          ...data
        }
      ];

      return {
        ...state,
        surprise_drop: {
          ...state.surprise_drop,
          products: {
            ...state.surprise_drop.products,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            status_code: status_code,
            hasMoreData: next_page_url
          }
        }
      };
    }
    case `${GET_COLLECTION_SURPRISE_DROP_LIST}${PROMISE_REJECTED}`:
      return {
        ...state,
        surprise_drop: {
          ...state.surprise_drop,
          products: {
            ...state.surprise_drop.products,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };
    case `${GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST}${PROMISE_PENDING}`:
      return {
        ...state,
        exclusive_launch: {
          ...state.exclusive_launch,
          products: {
            ...state.exclusive_launch.products,
            isFetching: true
          }
        }
      };
    case `${GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST}${PROMISE_FULFILLED}`: {
      const {
        data: {
          products: { data, next_page_url, current_page }
        },
        status_code
      } = action.payload;

      const newData = _.uniqBy(
        [...state.exclusive_launch.products.data, ...data],
        "id"
      );

      return {
        ...state,
        exclusive_launch: {
          ...state.exclusive_launch,
          products: {
            ...state.exclusive_launch.products,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            status_code: status_code,
            hasMoreData: next_page_url
          }
        }
      };
    }
    case `${GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST}${PROMISE_REJECTED}`:
      return {
        ...state,
        exclusive_launch: {
          ...state.exclusive_launch,
          products: {
            ...state.exclusive_launch.products,
            isFetching: false,
            error: error(action.payload)
          }
        }
      };
    case `${GET_POPULAR_BRANDS}${PROMISE_PENDING}`:
      return {
        ...state,
        categoryBrand: { ...state.categoryBrand, isFetching: true }
      };
    case `${GET_POPULAR_BRANDS}${PROMISE_FULFILLED}`: {
      return popularBrandList(state, action.payload.data);
    }
    case `${GET_POPULAR_BRANDS}${PROMISE_REJECTED}`:
      return {
        ...state,
        categoryBrand: {
          ...state.categoryBrand,
          isFetching: false,
          error: error(action.payload)
        }
      };

    case `${GET_RAFFLE_BANNER}${PROMISE_PENDING}`:
      return {
        ...state,
        raffleBanner: { ...state.raffleBanner, isFetching: true }
      };
    case `${GET_RAFFLE_BANNER}${PROMISE_FULFILLED}`: {
      const { data } = action.payload || {}
      return {
        ...state,
        raffleBanner: {
          ...state.raffleBanner,
          data
        }
      }
    }
    case `${GET_RAFFLE_BANNER}${PROMISE_REJECTED}`:
      return {
        ...state,
        raffleBanner: {
          ...state.raffleBanner,
          isFetching: false,
          error: error(action.payload)
        }
      };

    default:
      return state;
  }
};

export default kafairReducer;
